import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const FillMailWithBg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <rect width="32" height="32" rx="13" fill="var(--themis-insight-icon-bg, #2F354A)" />
    <path
      d="M20 9H12C9.6 9 8 10.2353 8 13.1176V18.8824C8 21.7647 9.6 23 12 23H20C22.4 23 24 21.7647 24 18.8824V13.1176C24 10.2353 22.4 9 20 9ZM20.376 14.0153L17.872 16.0741C17.344 16.5106 16.672 16.7247 16 16.7247C15.328 16.7247 14.648 16.5106 14.128 16.0741L11.624 14.0153C11.368 13.8012 11.328 13.4059 11.528 13.1424C11.736 12.8788 12.112 12.8294 12.368 13.0435L14.872 15.1024C15.48 15.6047 16.512 15.6047 17.12 15.1024L19.624 13.0435C19.88 12.8294 20.264 12.8706 20.464 13.1424C20.672 13.4059 20.632 13.8012 20.376 14.0153Z"
      fill="var(--themis-insight-icon-fg, #ffffff)"
    />
  </svg>
)

export default withDefaultStyles(FillMailWithBg)
